import React, { useState, useEffect } from 'react';
import T from 'prop-types';

import { isEmpty, debounce, orderBy } from 'lodash-es';


import AlertBlock from '../../../../../components/AlertBlock';
import { SortableTable } from '../../../../../components/SortableTable';
import { sdksColumns } from '../configs/table-config';
import scrollPage from '../../../../../utils/scrollPage';
import PayWall from '../../shared/components/PayWall';

import helpers, { isUnified, sdkImageUrl, canonicalSdkName } from '../../../../../utils/helpers';

const TopSdksTable = ({
  report,
  onShowMore,
}) => {
  const [rows, setRows] = useState([]);
  const emptyCell = <span>-</span>;
  const scrollTo = debounce(() => {
    const el = document.querySelector('.solutions-hubspot-form-box.solutions-hubspot-form');
    scrollPage({
      destination: el.getBoundingClientRect().y + 500,
      duration: 500,
    });
  }, 500);

  const setHeight = debounce(() => {
    const el = document.querySelector('.prospect-page-top-sdks table td.paywall-column .paywall-column-sticky-container');
    const tds = document.querySelectorAll('.prospect-page-top-sdks table td');
    const rowsLenght = rows.length;
    const paywelHeight = (rowsLenght * 56) - (rowsLenght * 7.25) + 65;
    el.style.height = `${paywelHeight}px`;
    el.style.marginTop = `${rowsLenght * 7.25}px`;
    const tdHieght = (paywelHeight / (rowsLenght - 1));
    tds.forEach((td) => {
      td.style.height = `${tdHieght < 61 ? 61 : tdHieght}px`;
    });
  },
  100);

  const handleShowMore = () => {
    onShowMore();
  };

  const {
    store,
    data: { sdks },
  } = report;
  const initialrows = sliced => sliced.map((td, i) => ({
    logo: (
      <img
        alt={td.name}
        className="img-fluid img-sdk-logo"
        src={sdkImageUrl(store, canonicalSdkName(td.name))}
        onError={(e) => { e.target.src = SDK_DEFAULT_LOGO_URL; }}
        loading="lazy"
      />
    ),
    name: (
      <div className="media-object app-link-block">
        <div className="media-body" style={{ maxWidth: '20vw' }}>
          <p className="text-truncate app-name text-xxs m-b-0 l-h-md">
            <a className="text-base text-blue" href={`/sdks/${isUnified(store) ? 'unified' : store}/${td.id}`} title={td.name}>
              {helpers.decodeEntities(td.name)}
            </a>
          </p>
        </div>
      </div>
    ),
    functions: SDK_FUNCTIONS[td.functions[0]] || 'Miscellaneous' || emptyCell,
    apptopia_rank: td.apptopia_rank || emptyCell,
    lifetime_installs: td.lifetime_installs || emptyCell,
    lifetime_uninstalls: td.lifetime_uninstalls || emptyCell,
    total_uninstalls: i === 0 ? <PayWall onClick={scrollTo} /> : null,
    total_uninstalls_td_props: {
      colSpan: 3,
      rowSpan: 50,
      id: 'paywall-column',
      className: 'bg-gray b-r b-b paywall-column',
    },
  }));

  useEffect(() => {
    setRows(initialrows(sdks.slice(0, 25)));
  }, []);

  useEffect(() => {
    setHeight();
  }, [rows]);

  const handleSort = (obj) => {
    const newRows = orderBy(sdks, [obj.sortBy], [obj.sortOrder]).slice(0, 25);
    const upRows = initialrows(newRows);
    setRows(upRows);
  };

  return (
    <div className="top-charts-main">
      <div className="top-charts-table-box">
        {!isEmpty(report) ? (
          <div className="table-responsive pos-rel">
            <SortableTable
              tableClassName="table-default sticky-header top-charts table-hover prospect-sdks-table"
              rows={rows}
              columns={sdksColumns}
              emptyStateText="No data to display"
              showMoreCellColSpan={10}
              showEmptyCells={false}
              showMoreCellSimplified
              hasShowMoreCell
              initialRowsLimit={25}
              onShowMore={handleShowMore}
              onSortEnd={handleSort}
            />
          </div>
        ) : (
          <AlertBlock type="warning" iconClass="hicon-warning">
            <p>Sorry, the Top Apps report is not available for apps matching these criteria.</p>
          </AlertBlock>
        )}
      </div>
    </div>
  );
};

TopSdksTable.propTypes = {
  report: T.object.isRequired,
  onShowMore: T.func.isRequired,
};

export default TopSdksTable;
